import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IConfigState, IAppState } from '../shared/models/store.model'
import { logOutApp } from '.'
import { defaultThemeConfig } from '../shared/constants/app.constants'

const initialState: IConfigState = {
  uiConfiguration: defaultThemeConfig,
}

const configReducer = createSlice({
  name: 'config',
  initialState,
  reducers: {
    updateUIConfiguration(state: any, action: PayloadAction<any>) {
      state.uiConfiguration = action.payload
    },
  },
  extraReducers: (builder: any) => {
    builder.addCase(logOutApp, () => {
      return initialState
    })
  },
})

const rootState = (state: IAppState) => state.config

export const getUiConfigurationState = createSelector(rootState, (state: IConfigState) => state.uiConfiguration)

export const { updateUIConfiguration } = configReducer.actions

export default configReducer
